import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import overviewAgentIdentityQuery from './src/ui/overview/__generated__/AgentOverviewInternalsQuery.graphql';

export const csmAgentOverviewEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(() =>
		import(
			/* webpackChunkName: "async-csm-agent" */ './src/ui/overview/AgentOverviewInternals.tsx'
		).then((module) => module.AgentOverview),
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: overviewAgentIdentityQuery,
				variables: {
					helpCenterAri: `ari:cloud:help::help-center/${tenantContext.activationId}/${context.match.params.helpCenterId}`,
					isVersioningEnabled: fg('csm_ai_agent_versioning'),
				},
			},
		},
	}),
});
